/** GET and write helpers over the authenticated client; errors carry the server's message. */
import { authedFetch } from "./api";
import { orThrow } from "./http";

export async function getJson<T>(path: string, what: string): Promise<T> {
  return (await orThrow(await authedFetch(path), what)) as T;
}

export async function send<T = unknown>(path: string, method: string, body: unknown, what: string): Promise<T> {
  const res = await authedFetch(path, {
    method,
    headers: { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  return (await orThrow(res, what)) as T;
}

/** A multipart POST (a photo plus fields). No Content-Type: the browser adds the boundary. */
export async function sendForm<T = unknown>(path: string, form: FormData, what: string): Promise<T> {
  return (await orThrow(await authedFetch(path, { method: "POST", body: form }), what)) as T;
}

/** A query string from the params that differ from their defaults ("" when none). */
export function qs(params: Record<string, string | number | boolean | null | undefined>): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === null || v === undefined || v === "" || v === false) continue;
    sp.set(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : "";
}
